export const LoaderWithMessagesStyle = {
  label: 'text-center',
  spinner: 'mt-12 mb-10',
}
